/* Очередь полноэкранных моментов (ACH-2) — финалы ачивок и серия, по одному, в порядке очереди.
   Портировано с clQueue/clQRun прототипа: открытые места кладутся сюда отовсюду (ответ finishDay/
   addMax/addMeasurement, лениво — me.newAch), показываются строго по одному с паузой между ними. */
import { useEffect, useState } from 'react';
import type { AchId } from './FirstSteps';

export type Moment =
  | { kind: 'ach'; id: AchId }
  | { kind: 'streak'; from: number; to: number; milestone: boolean; record: boolean; quote: [string, string] }
  | { kind: 'lost'; n: number; best: number; quote: [string, string] };

const q: Moment[] = [];
const subs = new Set<() => void>();
let current: Moment | null = null;
const notify = () => subs.forEach((f) => f());

function pump() {
  if (current) return;
  const m = q.shift();
  if (!m) return;
  current = m;
  notify();
}
export function enqueue(m: Moment) {
  q.push(m);
  setTimeout(pump, 300);
}
/** Текущий момент закрыт — следующий (если есть) выйдет через паузу */
export function dequeue() {
  current = null;
  notify();
  if (q.length) setTimeout(pump, 300);
}
export function useAchQueue() {
  const [, force] = useState(0);
  useEffect(() => {
    const f = () => force((x) => x + 1);
    subs.add(f);
    return () => {
      subs.delete(f);
    };
  }, []);
  return current;
}
